module.exports = __webpack_public_path__ + "media/images/default-person-1dd70ef4fba153a1f212c70c9335d72a.png";